import MapRepository from "../../interfaces/gateways/map.repository";

export default class SetMapCenterCase {
  constructor (
    private readonly mapRepo: MapRepository
  ) {
  }

  execute (lat: number, lng: number) {
    this.mapRepo.setLocation(lat, lng)
  }
}
